@if (mini()) {
    @if (storageUsageLoading() || storageUsage() || storageUsageFailed()) {
        <span
            class="mini-usage"
            [qpxTooltip]="miniTooltip()"
            [attr.aria-label]="miniTooltip()"
        >
            <ng-icon qpx name="lucideDatabase" size="sm" />
            @if (storageUsageLoading()) {
                <output>Loading storage…</output>
            } @else if (storageUsage()) {
                <span>{{ percentageLabel() }}</span>
                <mat-progress-spinner
                    class="usage-ring"
                    [attr.aria-label]="`Storage used: ${storageLabel()}`"
                    [diameter]="16"
                    [strokeWidth]="2"
                    mode="determinate"
                    [value]="progressPercentage()"
                />
            } @else {
                <output>Storage unavailable</output>
            }
        </span>
    }
} @else if (storageUsageLoading()) {
    <output class="block" aria-label="Loading storage used">
        <span qpxBody size="sm" class="storage-label font-semibold">
            {{ label() }}
        </span>
        <span class="storage-placeholder"></span>
    </output>
} @else if (storageUsage()) {
    <div class="storage-summary">
        <span qpxBody size="sm" class="storage-label font-semibold">
            {{ label() }}
        </span>
        <span qpxBody size="sm" class="storage-value font-semibold">
            {{ storageLabel() }}
        </span>
    </div>
    <mat-progress-bar
        class="storage-progress"
        mode="determinate"
        [value]="progressPercentage()"
        [attr.aria-label]="`Storage used: ${storageLabel()}`"
    />
} @else if (storageUsageFailed()) {
    <output qpxBody size="sm" aria-live="polite">
        Storage usage is temporarily unavailable. The effective storage limit
        still applies.
    </output>
}
